export const defaultBreakpoints = { mobile: 0, tablet: 768, desktop: 1280 };
